import React from 'react';
import { Typography } from '@mui/material';
import { StyledLanguageSelect, StyledMenuItem } from './styles';

interface ILanguageSelect {
  isVisible?: boolean;
}

const languages = [{ code: 'en', uniqueId: '02020', name: 'English' }];

const LanguageSelect = ({ isVisible = false }: ILanguageSelect) => {
  const [open, setOpen] = React.useState(false);
  const [country, setCountry] = React.useState(languages[0].code);

  const handleChange = (event: any) => {
    setCountry(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <StyledLanguageSelect
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      value={country}
      name="country"
      onChange={handleChange}
      inputProps={{
        id: 'open-select',
      }}
      MenuProps={{ sx: { marginTop: -1 } }}
    >
      {languages.map((option) => (
        <StyledMenuItem value={option.code} key={option.uniqueId}>
          <div>
            <Typography variant="body2">{option.name}</Typography>
          </div>
        </StyledMenuItem>
      ))}
    </StyledLanguageSelect>
  );
};

export { LanguageSelect };
